import { FilterColumn } from "types";

const manufacturerOrModelColumn = ({
	name = "manufacturerOrModel",
	placeholder = "Manufacturer/Model",
} = {}): FilterColumn => ({
	name,
	type: "input" as const,
	placeholder,
});

export default manufacturerOrModelColumn;
